import { render, staticRenderFns } from "./DossierList.vue?vue&type=template&id=5c681f0a&"
import script from "./DossierList.vue?vue&type=script&lang=js&"
export * from "./DossierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports